import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosPartnerPlatformInstance} from "../../ServerApiManager";
import {PartnerInfoRead} from "../../../declarations/server";

type PartnerInfoParams = {
  partnerCode: string | undefined;
};

export const getPartnerInfo = async (): Promise<PartnerInfoRead> => {
  const result = await axiosPartnerPlatformInstance.get<PartnerInfoRead, AxiosResponse<PartnerInfoRead>>(
    `/partner/info`
  );

  return result.data;
};

export const useGetPartnerInfoQuery = (
  params: PartnerInfoParams,
  options?: BaseQueryOptions<PartnerInfoRead, PartnerInfoParams>
): BaseUseQueryResult<PartnerInfoRead> => {
  return useBaseQuery<PartnerInfoRead, PartnerInfoParams>(
    ["partnerInfo", params.partnerCode],
    getPartnerInfo,
    params,
    options
  );
};
